module.exports = "/img/team.0911a92d.png";